import { render, staticRenderFns } from "./imageBpm.vue?vue&type=template&id=48b1cc07&scoped=true&"
import script from "./imageBpm.vue?vue&type=script&lang=js&"
export * from "./imageBpm.vue?vue&type=script&lang=js&"
import style0 from "./imageBpm.vue?vue&type=style&index=0&id=48b1cc07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b1cc07",
  null
  
)

export default component.exports